import { createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { id: "modal" }, null, -1)
const _hoisted_2 = { id: "app" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueQueryDevTools = _resolveComponent("VueQueryDevTools")!
  const _component_WalletSelectModal = _resolveComponent("WalletSelectModal")!
  const _component_SanctionedWalletModal = _resolveComponent("SanctionedWalletModal")!
  const _component_ThirdPartyServicesModal = _resolveComponent("ThirdPartyServicesModal")!
  const _component_AppSidebar = _resolveComponent("AppSidebar")!
  const _component_Notifications = _resolveComponent("Notifications")!
  const _component_GlobalModalContainer = _resolveComponent("GlobalModalContainer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.layout))),
      _createVNode(_component_VueQueryDevTools),
      _createVNode(_component_WalletSelectModal, {
        isVisible: _ctx.isWalletSelectVisible,
        onShowThirdParty: () => _ctx.handleThirdPartyModalToggle(true),
        onClose: _ctx.toggleWalletSelectModal
      }, null, 8, ["isVisible", "onShowThirdParty", "onClose"]),
      (_ctx.isBlocked)
        ? (_openBlock(), _createBlock(_component_SanctionedWalletModal, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_component_ThirdPartyServicesModal, {
        isVisible: _ctx.isThirdPartyServicesModalVisible,
        onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleThirdPartyModalToggle(false)))
      }, null, 8, ["isVisible"]),
      (_ctx.sidebarOpen)
        ? (_openBlock(), _createBlock(_component_AppSidebar, { key: 1 }))
        : _createCommentVNode("", true),
      _createVNode(_component_Notifications)
    ]),
    _createVNode(_component_GlobalModalContainer)
  ], 64))
}